<div class="doughnut-chart" [ngStyle]="{ width: width, left: left }">
  <canvas baseChart chartType="doughnut" [legend]="false" [data]="data?.data" [options]="doughnutChartOptions"
    [labels]="data?.labels" [colors]="colorArr">
  </canvas>

  <div class="doughnut-value" [ngStyle]="{ top: doughnutValueTop }">
    <div class="value-currency" *ngIf="valueUnit === '$' && !isShowNumber">
      ${{value || 0 | shortNumber}}
    </div>
    <div class="value-currency" *ngIf="valueUnit === '$' && isShowNumber">
      ${{value || 0 | number : '1.0-0'}}
    </div>
    <div class="font-500" *ngIf="valueUnit === 'K'">
      {{value || 0 | shortNumber}}
    </div>

    <div *ngIf="valueUnit !== '$' && valueUnit !== 'text' && valueUnit !== 'K'"
      class="doughnut-number isWithLargeNumber" [ngClass]="{'large-number': isLargeNumber()}">
      {{value || 0 | number : '1.0-0'}}{{valueUnit}}
    </div>

    <!-- Adding for tech summary reports -->
    <div *ngIf="valueUnit !== '$' && valueUnit !== 'text' && valueUnit !== 'K'" class="doughnut-number isWithOutLargeNumber"
      [ngClass]="{'large-number': isLargeNumber()}">
      {{valueTech || 0 | number : '1.0-0'}}{{valueUnit}}
    </div>

    <div *ngIf="valueUnit === 'text'" [innerHTML]="value" class="doughnut-text">
    </div>

    <div class="avg-value" [ngStyle]="{ 'font-size': avgValueFont }">
      {{avgValue}}
      <span *ngIf="valueUnit !== '$' && valueUnit !== 'text'  && valueUnit !== 'K'">
        {{valueUnit}}
      </span>
    </div>
  </div>

  <div class="doughnut-heading" [ngStyle]="{'top': doughnutHeadingTop}">
    <div class="doughnut-heading-inner" [ngStyle]="{'width': doughnutHeadingWidth}">
      <span [pTooltip]="tooltip" tooltipPosition="bottom" *ngIf="!brackHeading">
        {{ heading }}
      </span>

      <span [pTooltip]="tooltip" tooltipPosition="bottom" *ngIf="brackHeading">
        {{ isBrackHeading()[0] }} {{ isBrackHeading()[1] }}
      </span>

      <span *ngIf="subHeading !=null" class="sub-heading">
        {{subHeading | currency: usd: 'symbol':'1.0-0'}}
      </span>

      <span class="desciprtion" *ngIf="isDescription">
        {{description}}
      </span>
    </div>
  </div>
</div>
